import React, { useState } from "react";
import CatalogManager from "./CatalogManager";

const TABS = [
  { key: "categories", label: "Kategori" },
  { key: "brands", label: "Brand" },
  { key: "types", label: "Tipe" },
];

export default function CatalogSettings() {
  const [tab, setTab] = useState("categories");

  return (
    <div style={{ padding: 28, fontFamily: "system-ui,sans-serif", maxWidth: 900 }}>
      <h1 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", margin: "0 0 4px" }}>Kategori, Brand &amp; Tipe</h1>
      <div style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>
        Kelola daftar referensi yang dipakai di form tambah/edit produk.
      </div>

      <div style={{ display: "flex", gap: 6, marginBottom: 20, borderBottom: "1px solid #e2e8f0" }}>
        {TABS.map((t) => {
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              style={{
                padding: "10px 16px", border: "none", background: "none", cursor: "pointer",
                fontSize: 13, fontWeight: 700, color: active ? "#3b82f6" : "#64748b",
                borderBottom: active ? "2px solid #3b82f6" : "2px solid transparent",
                marginBottom: -1,
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === "categories" && (
        <CatalogManager
          tableName="categories"
          title="Kategori"
          idHint="contoh: display"
          extraFields={[{ key: "coverage_color", label: "Warna Coverage", type: "color" }]}
        />
      )}
      {tab === "brands" && (
        <CatalogManager tableName="brands" title="Brand" idHint="contoh: samsung" />
      )}
      {tab === "types" && (
        <CatalogManager tableName="types" title="Tipe" idHint="contoh: projector" />
      )}
    </div>
  );
}
